
export enum SyncStatus {
    IDLE = 'Idle',
    STARTED = 'Started',
    IN_PROGRESS = 'InProgress',
    COMPLETED = 'Completed',
}
